import React from "react";
import { Badge } from "./ui/badge";
import { readinessStatusClass } from "../lib/jobStatusFormat";
import { useLocalization } from "../hooks/useLocalization";

/** One readiness category (Environment / Core Services / Security / Operational HR Setup) -
 * every check shows its status badge + what it means; blocking gaps additionally surface the
 * required next action so this page can stand in for a deployment runbook, not just a status
 * light. */
export const ReadinessCategoryCard = ({ category }) => {
  const { t } = useLocalization();
  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-testid={`readiness-category-${category.key}`}>
      <div className="px-4 py-3 border-b border-gray-100 bg-gray-50">
        <h3 className="text-sm font-bold text-gray-800">{category.label}</h3>
      </div>
      <ul className="divide-y divide-gray-100">
        {category.checks.map((check) => (
          <li key={check.name} className="px-4 py-3" data-testid={`readiness-check-${check.name.replace(/\s+/g, "-").toLowerCase()}`}>
            <div className="flex items-center justify-between gap-3 flex-wrap">
              <span className="text-sm font-medium text-gray-800">{check.name}</span>
              <Badge className={readinessStatusClass(check.status)}>{t(`readinessStatus.${check.status}`)}</Badge>
            </div>
            <p className="text-xs text-gray-500 mt-1">{check.detail}</p>
            {check.impact === "BLOCKING" && (
              <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-md px-2 py-1 mt-2">
                <span className="font-semibold">{t("productionReadiness.nextAction")}:</span> {check.next_action}
              </p>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
